import React from 'react';

const CompliLogo = ({ variant = 'horizontal', theme = 'light', size = 'md' }) => {
  const sizes = {
    sm: { width: 120, height: 32 },
    md: { width: 200, height: 48 },
    lg: { width: 280, height: 64 },
    icon: { width: 48, height: 48 }
  };

  const colors = {
    light: {
      primary: '#0066CC',
      text: '#0066CC',
      accent: '#4DA6FF'
    },
    dark: {
      primary: '#4DA6FF',
      text: '#FFFFFF',
      accent: '#0066CC'
    },
    mono: {
      primary: '#495057',
      text: '#495057',
      accent: '#6c757d'
    }
  };

  const currentSize = sizes[size] || sizes.md;
  const currentColors = colors[theme] || colors.light;

  if (variant === 'icon') {
    return (
      <svg 
        width={sizes.icon.width} 
        height={sizes.icon.height} 
        viewBox="0 0 48 48" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(9, 12)">
          <path d="M12 0 L24 0 L30 8 L24 16 L12 16 L6 8 Z" fill={currentColors.primary} opacity="0.1"/>
          <path d="M12 4 L20 4 L24 10 L20 16 L12 16 L8 10 Z" fill={currentColors.primary} opacity="0.3"/>
          <path d="M12 8 L16 8 L18 11 L16 14 L12 14 L10 11 Z" fill={currentColors.primary}/>
          
          <circle cx="12" cy="0" r="2.5" fill={currentColors.primary}/>
          <circle cx="24" cy="0" r="2.5" fill={currentColors.primary}/>
          <circle cx="30" cy="8" r="2.5" fill={currentColors.primary}/>
          <circle cx="24" cy="16" r="2.5" fill={currentColors.primary}/>
          <circle cx="12" cy="16" r="2.5" fill={currentColors.primary}/>
          <circle cx="6" cy="8" r="2.5" fill={currentColors.primary}/>
        </g>
      </svg>
    );
  }

  if (variant === 'wordmark') {
    return (
      <svg 
        width={currentSize.width} 
        height={currentSize.height} 
        viewBox="0 0 200 48" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <text 
          x="100" 
          y="30" 
          fontFamily="'Helvetica Neue', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" 
          fontSize="28" 
          fontWeight="600" 
          fill={currentColors.text} 
          textAnchor="middle" 
          letterSpacing="3"
        >
          COMPLI
        </text>
      </svg>
    );
  }

  if (variant === 'stacked') {
    return (
      <svg 
        width="120" 
        height="80" 
        viewBox="0 0 120 80" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(45, 8)">
          <path d="M12 0 L24 0 L30 8 L24 16 L12 16 L6 8 Z" fill={currentColors.primary} opacity="0.1"/>
          <path d="M12 4 L20 4 L24 10 L20 16 L12 16 L8 10 Z" fill={currentColors.primary} opacity="0.3"/>
          <path d="M12 8 L16 8 L18 11 L16 14 L12 14 L10 11 Z" fill={currentColors.primary}/>
          
          <circle cx="12" cy="0" r="2" fill={currentColors.primary}/>
          <circle cx="24" cy="0" r="2" fill={currentColors.primary}/>
          <circle cx="30" cy="8" r="2" fill={currentColors.primary}/>
          <circle cx="24" cy="16" r="2" fill={currentColors.primary}/>
          <circle cx="12" cy="16" r="2" fill={currentColors.primary}/>
          <circle cx="6" cy="8" r="2" fill={currentColors.primary}/>
        </g>
        
        <text 
          x="60" 
          y="54" 
          fontFamily="'Helvetica Neue', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" 
          fontSize="20" 
          fontWeight="600" 
          fill={currentColors.text} 
          textAnchor="middle" 
          letterSpacing="2"
        >
          COMPLI
        </text>
      </svg>
    );
  }

  // Default horizontal variant
  return (
    <svg 
      width={currentSize.width} 
      height={currentSize.height} 
      viewBox="0 0 200 48" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Logomark */}
      <g id="logomark">
        <path d="M12 8 L24 8 L30 16 L24 24 L12 24 L6 16 Z" fill={currentColors.primary} opacity="0.1"/>
        <path d="M12 12 L20 12 L24 18 L20 24 L12 24 L8 18 Z" fill={currentColors.primary} opacity="0.3"/>
        <path d="M12 16 L16 16 L18 19 L16 22 L12 22 L10 19 Z" fill={currentColors.primary}/>
        
        {/* Neural network dots */}
        <circle cx="12" cy="8" r="2" fill={currentColors.primary}/>
        <circle cx="24" cy="8" r="2" fill={currentColors.primary}/>
        <circle cx="30" cy="16" r="2" fill={currentColors.primary}/>
        <circle cx="24" cy="24" r="2" fill={currentColors.primary}/>
        <circle cx="12" cy="24" r="2" fill={currentColors.primary}/>
        <circle cx="6" cy="16" r="2" fill={currentColors.primary}/>
      </g>
      
      {/* Wordmark */}
      <text 
        x="42" 
        y="28" 
        fontFamily="'Helvetica Neue', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" 
        fontSize="24" 
        fontWeight="600" 
        fill={currentColors.text} 
        letterSpacing="2"
      >
        COMPLI
      </text>
    </svg>
  );
};

export default CompliLogo;